import React from 'react';
import ABSListContainer from '../ABSListContainer';
import DetailRight from './DetailRight';
import './index.less';

export interface IABSListDetailContainerProps {
  title: string;
  columnsData: any;
  actionType: string;
  payload: Object;
  model: string;
  onRow?: (record: any, index: number) => void;
  renderRight: (record: any) => React.ReactNode;
  defaultSelectedIndex?: number;
}
 
export interface IABSListDetailContainerState {
  
}
 
class ABSListDetailContainer extends React.Component<IABSListDetailContainerProps, IABSListDetailContainerState> {
  static defaultProps = {
    defaultSelectedIndex: 0,
  };

  state = {
    showRight: false,
    record: null,
  };

  onClose = () => {
    const { showRight } = this.state;
    this.setState({ showRight: !showRight });
  }

  onRow = (record: any, index: number) => {
    const { defaultSelectedIndex } = this.props;
    if (index === defaultSelectedIndex) {
      if (!this.state.record) {
        this.setState({ showRight: true, record });
      }
    }

    return {
      onClick: () => {
        const { onRow } = this.props;
        if (onRow) {
          onRow(record, index);
        }
        this.setState({ showRight: true, record });
      }
    };
  }

  renderRight() {
    const { renderRight } = this.props;
    const { showRight, record } = this.state;
    if (showRight) {
      return (
        <DetailRight onClose={this.onClose}>
          {renderRight(record)}
        </DetailRight>
      );
    }
    return null;
  }

  render() { 
    const { columnsData, title, actionType, payload, model } = this.props;
    return (
      <div className="abs-list-detail-container">
        <div className="abs-list-detail-container-left">
          <ABSListContainer
            title={title}
            columnsData={columnsData} 
            actionType={actionType}
            payload={payload}
            model={model}
            onRow={this.onRow}
            selectable={true}
          />
        </div>
        {this.renderRight()}
      </div>
    );
  }
}
 
export default ABSListDetailContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSListDetailContainer/index.tsx